import {Component, Input, OnInit} from '@angular/core';
import {IdName} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'si-states-caption',
  templateUrl: './states-caption.component.html',
  styleUrls: ['./states-caption.component.scss']
})
export class StatesCaptionComponent {
  @Input() entity: string;
  states: IdName[];
  private _path: string;
  private _values: IdName[];

  constructor(private http: HttpClient) {
  }

  get path(): string {
    return this._path;
  }

  @Input()
  set path(val: string) {
    this._path = val;
    this.getStates();
  }

  get values(): IdName[] {
    return this._values;
  }

  @Input()
  set values(val: IdName[]) {
    this._values = val;
    if (val) {
      this.states = val;
    }
  }

  async getStates(): Promise<void> {
    this.states = await this.http.get<IdName[]>(this.path).toPromise();
  }
}
